import React, { Component } from "react";
import { NavLink } from "react-router-dom";

import HeaderLinks from "../Header/HeaderLinks.jsx";

import defaultLogo from "assets/img/ic_launcher.png";
import { connect } from 'react-redux';
import dashboardRoutes from "routes/dashboard.jsx";
import {basePath} from 'helper/basePath';

class SidebarPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      width: window.innerWidth,
      companyImage:this.props.userAdmin?this.props.userAdmin.user.image:'',
      dashboardName: this.props.adminType? this.props.adminType === 'admin'?'PHOTOVISION':this.props.userAdmin.user.company_name:'' ,
    };
  }


  activeRoute(routeName) {
    return this.props.location.pathname.indexOf(routeName) > -1 ? "active" : "";
  }
  updateDimensions() {
    this.setState({ width: window.innerWidth });
  }
  componentDidMount() {
    this.updateDimensions();
    window.addEventListener("resize", this.updateDimensions.bind(this));
  }
  render() {
    
    return (
      <div
        id="sidebar"
        className="sidebar"
        data-color="#2c3356"
      >
        <div className="sidebar-background"/>
        <div className="logo">
          <a
            href={basePath+'Admin'}
            className="simple-text logo-mini"
          >
            <div className="logo-img">
              <img src={this.state.companyImage?this.state.companyImage:defaultLogo} alt="logo_image" height="40px" width="40px"/>
            </div>
          </a>
          <a
            href={basePath+'Admin'}
            className="simple-text logo-normal"
          >
            { this.state.dashboardName }
          </a>
        </div>
        {
          this.props.adminType &&
          <div className="sidebar-wrapper">
            <ul className="nav">
              {this.state.width <= 991 ? <HeaderLinks /> : null}
              {dashboardRoutes.map((prop, key) => {
                if (!prop.redirect && prop.showMenu && (prop.permission === this.props.adminType || prop.permission ==='both') && (prop.path !== '/Admin/Company-Users') )
                  return (
                    <li
                      className={
                        prop.upgrade
                          ? "active active-pro"
                          : this.activeRoute(prop.path)
                          +" iconNavSidebar"
                      }
                      key={key}
                    >
                      <NavLink
                        to={prop.path}
                        className="nav-link"
                        activeClassName="active"
                      >
                        <img src={prop.iconImagePath} alt="iconImagePath" />
                        <p>{prop.name}</p>
                      </NavLink>
                    </li>
                  );
                else if (!prop.redirect && prop.showMenu && (prop.permission === this.props.adminType || prop.permission ==='both') ) 
                  return (
                    <li
                      className={
                        prop.upgrade
                          ? "active active-pro"
                          : this.activeRoute(prop.path)
                          +" iconNavSidebar"
                      }
                      key={key}
                    >
                      <NavLink
                        to={prop.path}
                        className="nav-link"
                        activeClassName="active"
                      >
                        <img src={prop.iconImagePath} alt="iconImagePath" />
                        <p>{prop.name}</p>
                      </NavLink>
                    </li>
                  );
                return null;
              })}
            </ul>
          </div>
        }
        
      </div>
    );
  }
}


function mapStateToProps(state) {
    const { adminType, userAdmin } = state.adminReducer;
    return {
        adminType, userAdmin
    };
}

const Sidebar = connect(mapStateToProps)(SidebarPage);


export default Sidebar;




// WEBPACK FOOTER //
// ./src/components/Admin/Sidebar/Sidebar.jsx